// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor-screen {
  display: flex;
  justify-content: space-between;
  max-width: 1440px;
  width: 100%;
}
@media (max-width: 768px) {
  .editor-screen {
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/builder/theme-layout/index.scss"],"names":[],"mappings":"AAEE;EACE,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,WAAA;AADJ;AAGI;EANF;IAOI,sBAAA;EAAJ;AACF","sourcesContent":[".editor {\n\n  &-screen {\n    display: flex;\n    justify-content: space-between;\n    max-width: 1440px;\n    width: 100%;\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n    }\n  }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
